'use strict';

/*
We have 2 login options:
- Regular login flow (/login page)
- Modal iframe login (it opens a modal with an iframe pointing to /login/iframe)

The login iframe is loaded after everything else has been loaded.

If the user clicks on something that requires authentication before the iframe has been loaded,
then they will be redirected to the regular login flow. This is to prevent a problem with the iframe
interfering with the login flow.
*/

let iframeLoaded = false;
window.MPP.JsonResponseHandler = class {
  static getCurrentUrl() {
    return `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  }

  static redirectToLogin() {
    // Touch login uses the return_to query parameter.
    // Desktop login uses the ref query parameter.
    window.OptimizeSuite.TrackingHub.add('MerchantPage-Login-Redirect');
    const currentUrl = encodeURIComponent(this.getCurrentUrl());
    const loginLink = `/login?ref=${currentUrl}&return_to=${currentUrl}`;
    window.location.href = loginLink;
    return window.location.href;
  }

  static openModalIframeLogin() {
    window.OptimizeSuite.TrackingHub.add('MerchantPage-Login-Modal');

    if (!this.iframeLoginInitialized) {
      window.IframeLogin.init({
        iframeLogin: {
          // We will open the modal manually after getting an error response from the server, not with "data-login-required",
          // so it's safe to set this to false all the time.
          authenticated: false,
          authType: 'login',
          src: '/login/iframe',
        },
      });
      this.iframeLoginInitialized = true;
    }

    return window.IframeLogin.openModal(this.getCurrentUrl());
  }

  static loginRequired(res, options = {}) {
    if (
      __guard__(res != null ? res.error : undefined, x => x.code) !==
      'login-required'
    ) {
      return false;
    }

    if (options.method === 'redirect' || !$('#login-modal').length) {
      this.redirectToLogin();
    } else if (iframeLoaded === true) {
      this.openModalIframeLogin();
    } else {
      // If the iframe has not been loaded yet, we set an interval to check when it's ready.
      // This weird logic is necessary because of how the groupon-iframe-login module works:
      // it will automatically reload the page if the user tries to open the modal before the iframe has been loaded.
      const start = new Date().getTime();

      let interval;
      const waitForIframeToLoad = () => {
        const now = new Date().getTime();

        if (!iframeLoaded && now - start > 2500) {
          // redirect to login if iframe fails to load in 2.5 seconds
          clearInterval(interval);
          this.redirectToLogin();
          return;
        }

        if (iframeLoaded !== true) {
          return;
        }

        clearInterval(interval);
        this.openModalIframeLogin();
      };
      interval = setInterval(waitForIframeToLoad, 250);
    }

    return true;
  }
};
$(window).load(() => {
  // delay the iframe loading until after everything else has been loaded
  const $iframe = $('#login-modal iframe');

  if (!$iframe.length) {
    return;
  }

  $iframe.attr('src', '/login/iframe');
  $iframe.attr('height', '503');
  $iframe.load(() => {
    iframeLoaded = true;
  });
});

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null
    ? transform(value)
    : undefined;
}
